import {
  IconColor,
  IconName,
} from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import { TicketPriority } from '@delmonicos/shared-sdk/libs/cpms/src/libs/support-service-lib/src/wrapper/enums/ticket-priority.enum';

export interface PriorityTagConfig {
  icon: IconName;
  iconColor: IconColor;
  tagClass: string;
}

/**
 * `chevron-up-double`/`chevron-down-double` don't exist yet in
 * delmonicos-shared-design-system-core's icon set — used here ahead of that
 * addition, so they'll render as a missing glyph until added there.
 */
export const PRIORITY_CONFIG: Record<TicketPriority, PriorityTagConfig> = {
  [TicketPriority.Urgent]: {
    icon: 'chevron-up-double' as IconName,
    iconColor: IconColor.Error,
    tagClass: 'bg-surface-error',
  },
  [TicketPriority.High]: {
    icon: 'chevron-up',
    iconColor: IconColor.Warning,
    tagClass: 'bg-surface-warning',
  },
  [TicketPriority.Normal]: {
    icon: 'minus',
    iconColor: IconColor.Secondary,
    tagClass: 'bg-surface-secondary',
  },
  [TicketPriority.Low]: {
    icon: 'chevron-down-double' as IconName,
    iconColor: IconColor.Informations,
    tagClass: 'bg-surface-informations',
  },
};

export const PRIORITY_ORDER: TicketPriority[] = [
  TicketPriority.Low,
  TicketPriority.Normal,
  TicketPriority.High,
  TicketPriority.Urgent,
];
